<template functional>
  <div class="row mb-4 justify-content-center">
    <div class="col-auto">
      <component :is="injections.components.Title" v-bind="data.attrs">
        <slot />
      </component>
    </div>
  </div>
</template>

<script>
import Title from '@/components/atoms/Title';
export default {
  name: 'TitleContent',
  inject: {
    components: {
      default: {
        Title,
      },
    },
  },
};
</script>
